import { Link } from 'react-router-dom'
import Seo, { SITE_URL } from '@/components/Seo'
import AdSlot from '@/components/AdSlot'
import SponsoredSlot from '@/components/SponsoredSlot'
import CalculatorTool from '@/components/calculator/CalculatorTool'
import CalculatorContent from '@/components/calculator/CalculatorContent'
import FaqList, { faqSchema } from '@/components/FaqList'
import { FAQS } from '@/data/faqs'
import { POSTS } from '@/data/blog'

function CalculatorPage() {
  const faqs = FAQS.slice(0, 6)
  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: 'Dormer Calculator',
      url: `${SITE_URL}/calculator`,
      description:
        'Free online dormer calculator that estimates roof area, wall area, materials needed and construction cost from width, depth, height, roof pitch and material.',
      applicationCategory: 'UtilitiesApplication',
      operatingSystem: 'Any (web browser)',
      browserRequirements: 'Requires JavaScript',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
      featureList: [
        'Roof, wall and floor area',
        'Materials list with waste allowance',
        'Construction cost estimate and range',
        'Imperial and metric units',
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Dormer Calculator', item: `${SITE_URL}/calculator` },
      ],
    },
    faqSchema(faqs),
  ]

  return (
    <>
      <Seo
        title="Dormer Calculator: Free Cost, Materials & Roof Area Estimator"
        description="Free dormer calculator. Enter width, depth, height, roof pitch and material to instantly see materials needed, roof area and estimated construction cost."
        path="/calculator"
        schema={schema}
      />

      <div className="border-b border-steel-200 bg-white">
        <div className="container-page py-8 sm:py-10">
          <nav aria-label="Breadcrumb" className="mb-3 text-sm text-steel-500">
            <Link to="/">Home</Link> <span aria-hidden="true">/</span> <span aria-current="page">Calculator</span>
          </nav>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl">Dormer Calculator</h1>
          <p className="mt-3 max-w-2xl text-lg">
            Enter your measurements to get roof area, a materials list and an estimated construction cost. Results update as you type.
          </p>
        </div>
      </div>

      <div className="container-page py-8 sm:py-10">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_300px]">
          <div className="min-w-0 space-y-12">
            <CalculatorTool />
            <AdSlot variant="banner" label="Advertisement" />
            <CalculatorContent />

            <section aria-labelledby="calc-faq">
              <h2 id="calc-faq" className="text-2xl sm:text-3xl">Calculator questions</h2>
              <div className="mt-5">
                <FaqList items={faqs} />
              </div>
            </section>

            <AdSlot variant="banner" label="Advertisement" />
          </div>

          <aside aria-label="Sidebar" className="hidden lg:block">
            <div className="sticky top-24 space-y-6">
              <SponsoredSlot />
              <AdSlot variant="sidebar" label="Advertisement" />
              <div className="card p-5">
                <h2 className="text-lg">Related guides</h2>
                <ul className="mt-3 space-y-3">
                  {POSTS.slice(0, 4).map(p => (
                    <li key={p.slug}>
                      <Link to={`/blog/${p.slug}`} className="text-sm font-semibold">{p.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </>
  )
}

export default CalculatorPage
